"use client";

import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "expirydesk_saved_slugs";

function readSaved(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === "string") : [];
  } catch {
    return [];
  }
}

type Props = { slug: string; title: string };

export function BlogSaveArticleButton({ slug, title }: Props) {
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setSaved(readSaved().includes(slug));
  }, [slug]);

  const toggle = useCallback(() => {
    const cur = readSaved();
    let next: string[];
    if (cur.includes(slug)) {
      next = cur.filter((s) => s !== slug);
      setSaved(false);
    } else {
      next = [...cur, slug];
      setSaved(true);
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      /* quota */
    }
    window.dispatchEvent(new Event("expirydesk-saved-change"));
  }, [slug]);

  return (
    <button type="button" className="ed-blog-save-btn" onClick={toggle} aria-pressed={saved} aria-label={saved ? `Saved: ${title}` : `Save article: ${title}`}>
      {saved ? "Saved" : "Save article"}
    </button>
  );
}

export function getSavedSlugsFromStorage(): string[] {
  return readSaved();
}
